export default __webpack_public_path__ + "static/media/header.34d30032.JPG";